import React from 'react'
import { useSelector } from 'react-redux'

const accidentStyle = { background: '#DC3545', color: '#fff', padding: '1px 6px', borderRadius: '3px', fontSize: '10px', fontWeight: 600, marginLeft: '6px', whiteSpace: 'nowrap' }
const breakdownStyle = { background: '#FF8C00', color: '#fff', padding: '1px 6px', borderRadius: '3px', fontSize: '10px', fontWeight: 600, marginLeft: '4px', whiteSpace: 'nowrap' }

const BreakdownBadge = React.memo(({ registrationNumber }) => {
  const vehicleInfo = useSelector(state => {
    const map = state.breakdownTickets.vehicleMap
    if (!map || !registrationNumber) return null
    return map[registrationNumber.toUpperCase()] || null
  })

  if (!vehicleInfo) return null

  return (
    <>
      {vehicleInfo.hasAccident && <span style={accidentStyle}>Accident</span>}
      {vehicleInfo.hasBreakdown && <span style={breakdownStyle}>Breakdown</span>}
    </>
  )
})

export default BreakdownBadge
